import { useEffect, useState } from 'react';
import storeApis from 'modules/store/services/apis';
import { IStore } from 'modules/store/interfaces/api';

const useGetAllStores = () => {
  const [stores, setStores] = useState<IStore[]>([]);
  useEffect(() => {
    const handleFetchAllStores = async () => {
      const res = await storeApis.getListStores({ page: 1, size: 1000 });

      if (res?.data?.data?.content) {
        setStores(res.data.data.content);
      }
    };

    handleFetchAllStores();
  }, []);

  return [stores] as const;
};

export default useGetAllStores;
